<template>
  <el-form ref="form"
           :model="form"
           :rules="formRules"
           size="medium"
           label-width="140px"
           @submit.native.prevent="onSubmit()">
    <div class="re-el-form__flex">
      <div class="medium">
        <el-form-item :label="displayName"
                      prop="tags">
          <el-select
            v-model="form.tags"
            multiple
            multiple-limit="1"
            filterable
            remote
            reserve-keyword
            placeholder="请输入标签名"
            :remote-method="remoteTagMethod"
            :loading="loading">
            <el-option
              v-for="item in options.tags"
              :key="item.id"
              :label="item.tagname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户选择方式"
                      prop="addType"
                      size="mini">
          <el-radio-group v-model="form.addType">
            <el-radio :label="0">ID</el-radio>
            <el-radio :label="1">手机号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因"
                      prop="reason">
            <el-input v-model="form.reason"
                      placeholder="请填写操作原因，最多支持100字符">
            </el-input>
        </el-form-item>
        <el-form-item label="用户ID列表"
                      v-if="form.addType * 1 === 0"
                      prop="userids">
          <el-input v-model="form.userids"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5}"
                    placeholder="多个用户请使用回车"></el-input>
        </el-form-item>
        <el-form-item label="用户手机号列表"
                      v-if="form.addType * 1 === 1"
                      prop="phones">
          <el-input v-model="form.phones"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5}"
                    placeholder="多个用户请使用回车"></el-input>
        </el-form-item>
      </div>
    </div>
    <el-form-item>
      <el-button type="primary"
                 native-type="submit">提交表单
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {},
  props: {
    displayName: String,
  },
  data () {
    return {
      loading: false,
      form: {
        tags: [],
        userids: '',
        phones: '',
        addType: 0,
        reason: '',
      },
      options: {
        tags: [],
      },

      formRules: {
        tags: [
          {required: true, message: '请至少选择一个标签', trigger: 'blur'},
        ],
        addType: [
          {required: true, message: '用户选择方式必选', trigger: 'blur'},
        ],
        userids: [
          {required: true, message: '用户ID列表不能为空', trigger: 'blur'},
        ],
        phones: [
          {required: true, message: '用户手机号列表不能为空', trigger: 'blur'},
        ],
      }
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm (id) {
    },
    remoteTagMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          request.alert('getUserTagName', {query: query}).then(({data}) => {
            this.options.tags = data
            this.loading = false
          })
        }, 500)
      } else {
        this.options.tags = []
      }
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.checkUserList()) {
            this.$emit('submit', this.form)
          }
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    checkUserList () {
      if (this.form.addType === 0) {
        const uIds = this.form.userids
        if (_.isEmpty(uIds)) {
          this.$message.error('用户ID列表不能为空！')
          return false
        }
        return this.userIdsValidator(uIds)
      }
      if (this.form.addType === 1) {
        const phones = this.form.phones
        if (_.isEmpty(phones)) {
          this.$message.error('用户手机号列表不能为空！')
          return false
        }
        return this.userIdsValidator(phones)
      }
    },
    // 验证用户id中是否有非数字字符
    userIdsValidator (value) {
      const re = /^([0-9]+(\s|[\r\n])*)*$/g
      if (!re.test(value)) {
        this.$message.error('用户列表中首行为空，或者包含非数字字符！')
        return false
      }
      return true
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/user-batch-tag/components/UserBatchTagForm.vue